export default "__VITE_ASSET__CFMiooXv__"